@if (canEdit || canDelete || canPin || canReport) {
  <div class="pm">
    <button
      type="button"
      class="pm-trigger"
      [class.is-open]="open"
      aria-haspopup="menu"
      [attr.aria-expanded]="open"
      [attr.aria-label]="label"
      [title]="label"
      (click)="toggle()">
      <i class="fa fa-ellipsis-h"></i>
    </button>

    @if (open) {
      <div class="pm-menu" role="menu">
        @if (canPin) {
          <button type="button" role="menuitem" class="pm-item pm-pin" (click)="choose('pin')">
            <i class="fa fa-thumb-tack"></i> {{ pinned ? 'Unpin' : 'Pin to top' }}
          </button>
        }
        @if (canEdit) {
          <button type="button" role="menuitem" class="pm-item pm-edit" (click)="choose('edit')">
            <i class="fa fa-pencil"></i> Edit
          </button>
        }
        @if (canDelete) {
          <button type="button" role="menuitem" class="pm-item pm-delete" (click)="choose('remove')">
            <i class="fa fa-trash"></i> Delete
          </button>
        }
        @if (canReport) {
          <button type="button" role="menuitem" class="pm-item pm-report" (click)="choose('report')">
            <i class="fa fa-flag"></i> Report
          </button>
        }
      </div>
    }
  </div>
}
